import styled from 'styled-components';

export const NewApplicationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
`;

export const ApplicationRegistrationBlock = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;

  .text {
    font-size: 25px;
    color: #59718e;
  }

  .ant-picker {
    height: 35px;
  }

  input {
    height: 35px;
  }
`;
